/**
 * 計算フィールドの内訳で、値を数値として読むかどうかの判定（#3412）。
 *
 * 計算エンジン（utils/calculation の evaluator.ts / conversion.ts）と同じ形式だけを数値とみなす。
 * Number() は "1e3" や "0x10" も数値にしてしまい、エンジンの判定とずれるため使わない。
 * エンジンは functions/ と二重実装のため、ここでは定義を複製して画面表示側だけで使う。
 */

/** カンマ除去後に数値として解釈できる形式（エンジンの NUMERIC_PATTERN と同じ） */
const NUMERIC_PATTERN = /^[+-]?[0-9]+(\.[0-9]+)?$/;

/** 数値として読めれば数値を、読めなければ undefined を返す（"1,000" → 1000） */
export const parseNumericValue = (value: string): number | undefined => {
  const normalized = value.trim().replace(/,/g, '');
  return NUMERIC_PATTERN.test(normalized) ? Number(normalized) : undefined;
};
